export default "__VITE_ASSET__BzsE_q4e__"